// Navigatie
// Modern version using ES6+ and better practices
// Constants for better maintainability
const BREAKPOINT = 991;
const selectors = {
  navMain: ".nav-main",
  navSecondary: ".nav-secondary",
  navWrapper: ".nav-wrapper",
  navListWrapper: ".nav-list-wrapper",
  navToggler: ".nav-toggler",
  navTogglerIcon: ".nav-toggler-icon",
  navTitleBar: ".nav-title-bar",
  dropdown: ".has-dropdown",
  searchForm: "header .form-search",
  notification: ".notificatie",
  accordionHead: ".accordion-item .accordion-item-head",
};

function setupNavigation() {
  // Custom debounce function (no Lodash dependency)
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Plugin methods
  const NavPlugin = {
    // ToggleNav show/hide mobiele navigatie
    toggleNav() {
      const $body = $("html,body");
      $(selectors.navTogglerIcon).toggleClass("active");
      $(selectors.navTitleBar).find("div").removeClass("show");
      $(selectors.navWrapper).removeClass("l2").toggleClass("show");
      $(selectors.navListWrapper).removeClass("l2");
      $body.toggleClass("no-scroll");
      return this;
    },

    showBackdrop(options = {}) {
      const settings = {
        selectors: [selectors.navMain],
        classes: ["active"],
        ...options,
      };

      const $backdrop = $('<div class="modal-backdrop fade show"></div>');

      const cleanup = () => {
        $backdrop.remove();
        settings.selectors.forEach((selector) =>
          $(selector).removeClass(settings.classes.join(" ")),
        );
        $(document).off("keydown.backdrop");
      };

      $backdrop.on("click", cleanup).appendTo("body");

      $(document).on("keydown.backdrop", (e) => {
        if (e.key === "Escape") cleanup();
      });

      return $backdrop;
    },

    toggleBackdrop(options = {}) {
      const $existingBackdrop = $(".modal-backdrop");

      if ($existingBackdrop.length) {
        $existingBackdrop.remove();
        $(document).off("keydown.backdrop");
        return this;
      }

      return this.showBackdrop(options);
    },
  };

  // Extend jQuery with our plugins
  $.fn.extend(NavPlugin);

  // Initialize search form
  $(selectors.searchForm).blur();

  // Initialize the appropriate navigation based on initial viewport
  if ($(window).width() > BREAKPOINT) {
    initDesktopNav();
    $("body").addClass("desktop-nav").removeClass("mobile-nav");
  } else {
    initMobileNav();
    $("body").addClass("mobile-nav").removeClass("desktop-nav");
  }

  // General handlers
  initGeneralHandlers();

  // Resize handler with debounce to switch between mobile/desktop modes
  $(window).on(
    "resize",
    debounce(() => {
      const width = $(window).width();
      if (width > BREAKPOINT && $("body").hasClass("mobile-nav")) {
        // Switch from mobile to desktop
        $("body").addClass("desktop-nav").removeClass("mobile-nav");
        // Clean up mobile-specific states
        cleanupMobileNav();
        // Initialize desktop nav
        initDesktopNav();
      } else if (width <= BREAKPOINT && $("body").hasClass("desktop-nav")) {
        // Switch from desktop to mobile
        $("body").addClass("mobile-nav").removeClass("desktop-nav");
        // Clean up desktop-specific states
        cleanupDesktopNav();
        // Initialize mobile nav
        initMobileNav();
      }
    }, 250),
  );

  // Add cleanup functions for each mode
  function cleanupMobileNav() {
    // Remove mobile-specific event handlers
    $(selectors.dropdown).off("click");
    $(".nav-back-link a").off("click");
    // Reset mobile navigation states
    $(selectors.navWrapper).removeClass("l2 show");
    $(selectors.navListWrapper).removeClass("l2");
    $(selectors.dropdown).removeClass("show");
    $(selectors.navTitleBar).find("div").removeClass("show");
    $(".nav-title").html("");
  }

  function cleanupDesktopNav() {
    // Store this selector for reuse
    const dropdownTriggers = `${selectors.navMain} > ${selectors.dropdown} > span, ${selectors.navMain} > ${selectors.dropdown} > a`;

    // Remove all event handlers
    $(dropdownTriggers).off("click touchstart touchend");
    $(dropdownTriggers).off("keydown");
    $(document).off("click.backdrop touchend.backdrop");

    // Reset all states
    $(selectors.navMain).removeClass("active");
    $(`${selectors.dropdown}`).removeClass("touch-active was-active");
    $(".modal-backdrop").remove();
  }

  // Desktop navigation initialization
  function initDesktopNav() {
    // Check for touch capability
    const isTouchDevice =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;
    console.log("Is touch device:", isTouchDevice);

    // Store this selector for reuse
    const dropdownTriggers = `${selectors.navMain} > ${selectors.dropdown} > span, ${selectors.navMain} > ${selectors.dropdown} > a`;

    // Handle desktop navigation differently depending on device type
    if (isTouchDevice) {
      // For touch devices, use a simpler approach that's more reliable
      $(dropdownTriggers).on("click touchend", function (e) {
        e.preventDefault();
        e.stopPropagation();

        console.log("Click/touch on:", this);

        const $parent = $(this).parent();
        const isActive = $(selectors.navMain).hasClass("active");

        // Always clear existing state first
        $(`${selectors.dropdown}`).removeClass("touch-active");

        // If clicking the already active dropdown, close it
        if (isActive && $parent.hasClass("was-active")) {
          $(selectors.navMain).removeClass("active");
          $parent.removeClass("was-active");
          $(".modal-backdrop").remove();
        }
        // Otherwise, activate this dropdown
        else {
          $(selectors.navMain).addClass("active");
          $parent.addClass("touch-active was-active");
          $parent.toggleBackdrop();

          // Close when clicking outside
          $(document).one("click touchend", function (event) {
            if (!$(event.target).closest($parent).length) {
              $(selectors.navMain).removeClass("active");
              $parent.removeClass("touch-active was-active");
              $(".modal-backdrop").remove();
            }
          });
        }

        return false;
      });
    } else {
      // For non-touch devices, use the hover-like approach
      $(dropdownTriggers).on("click", function (e) {
        e.preventDefault();
        $(selectors.navMain).toggleClass("active");
        $(this).parent().toggleBackdrop();
      });
    }

    // Handle keyboard navigation (Enter key) - works the same for all devices
    $(dropdownTriggers).on("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        $(selectors.navMain).toggleClass("active");
        $(this).parent().toggleBackdrop();
      }
    });

    // Search focus handlers
    $(selectors.searchForm).on({
      focus() {
        if (!$(selectors.navMain).hasClass("active")) {
          $(selectors.navMain).addClass("active");
          $(this).toggleBackdrop();
        }
      },
      blur() {
        if (!$(selectors.navMain).hasClass("active")) {
          $(selectors.navMain).removeClass("active");
          $(this).toggleBackdrop();
        }
      },
    });

    // Dynamic height calculation
    const updateHeight = () => {
      const BASE_HEIGHT = 240;
      const maxHeight = Math.max(
        ...$(".nav-list")
          .map((_, el) => $(el).height())
          .get(),
      );
      $(selectors.navListWrapper).outerHeight(maxHeight + BASE_HEIGHT);
    };

    // Initial height calculation
    updateHeight();

    // Debounced resize handler for height calculation
    $(window).on("resize", debounce(updateHeight, 250));

    // Reset nav Secondary
    $(selectors.navSecondary).css("top", "0px");
  }

  // Mobile navigation initialization
  function initMobileNav() {
    // Reposition nav-secondary
    const navSecPosition = () => {
      const searchHeight = $("li.has-searchbar").height();
      const navListHeight = $(
        selectors.navListWrapper + " > .container",
      ).height();
      const yPos = searchHeight + navListHeight;
      $(selectors.navSecondary).css("top", yPos + "px");
    };

    // Toggle navigation
    $(selectors.navToggler).on("click", function (e) {
      e.preventDefault();
      $(this).toggleNav();
      navSecPosition();
    });

    // Level 2 navigation - improved event handling
    $(selectors.dropdown).on("click", function (e) {
      // Only handle this event if we're not already in level 2 navigation
      if (!$(selectors.navWrapper).hasClass("l2")) {
        // Check if the clicked element is a direct child link of the dropdown
        const $target = $(e.target);
        const isDirectLink =
          $target.is("a.nav-list-link, span.nav-list-link") &&
          $target.parent().is(selectors.dropdown);

        // If the dropdown itself or its direct link was clicked
        if ($target.is(selectors.dropdown) || isDirectLink) {
          e.preventDefault();

          const categoryText = $(this).find("> .nav-list-link").text();

          $(this).addClass("show");
          $(selectors.navWrapper).addClass("l2");
          $(selectors.navListWrapper).addClass("l2");

          const $titleBar = $(selectors.navTitleBar);
          $titleBar.find("div").addClass("show");
          $titleBar.find(".nav-title").html(categoryText);
        }
      }
    });

    // Back navigation
    $(".nav-back-link a").on("click", function (e) {
      e.preventDefault();
      $(selectors.dropdown).removeClass("show");
      $(selectors.navWrapper).removeClass("l2");
      $(selectors.navListWrapper).removeClass("l2");
      $(".nav-title").html("");
      $(selectors.navTitleBar).find("div").removeClass("show");
    });
  }

  // General handlers initialization - using event delegation for better performance
  function initGeneralHandlers() {
    // Notification handler
    $(document).on("click", selectors.notification, function () {
      $(this).removeClass("is-visible");
    });

    // Accordion handler
    $(document).on("click", selectors.accordionHead, function () {
      $(this).parent().toggleClass("is-active");
    });

    // Global escape key handler
    $(document).on("keyup", function (e) {
      if (e.key === "Escape") {
        closeNavigation();
      }
    });
  }
}

function closeNavigation() {
  $("html,body").removeClass("no-scroll");
  $(selectors.navMain).removeClass("active");
  $(selectors.searchForm).blur();
  $(".modal-backdrop").remove();
}

export { setupNavigation, closeNavigation };
